import { combineReducers } from "redux"
import { reducer as bus_stopTable } from './bus_stopTable/bus_stopTableRedux'
export const reducer = combineReducers( { bus_stopTable } )
